import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 课程分类列表
  classifyList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/classify/classifyList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 课程分类详情
  classifyDetail(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/classify/classifyDetail?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 课程分类新增
  classifyAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/classify/classifyAdd`,
      method: 'post',
      data,
    });
  },
  // 课程分类编辑
  classifyUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/classify/classifyUpdate`,
      method: 'post',
      data,
    });
  },
  // 课程分类删除
  classifyDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/classify/classifyDelete`,
      method: 'post',
      data,
    });
  },
};
